import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import "./HolidaySection.css";
import shimla from "../../assets/shimla.jpg";
import udaipur from "../../assets/udaipur.jpg";
import jaisalmer from "../../assets/jaisalmer.jpg";
import manali from "../../assets/manali.png";
import goa from "../../assets/goa.png";
import kerala from "../../assets/kerala.png";
import ooty from "../../assets/ooty.png";
import darjeeling from "../../assets/darjeeling.png";
import andaman from "../../assets/andaman.png";
import jaipur from "../../assets/jaipur.png";
import rishikesh from "../../assets/rishikesh.png";
import ladakh from "../../assets/ladakh.png";
import spiti from "../../assets/spiti.png";
import kasol from "../../assets/kasol.png";
import meghalaya from "../../assets/meghalaya.png";
import varanasi from "../../assets/varanasi.png";
import rameshwaram from "../../assets/rameshwaram.png";
import tirupati from "../../assets/tirupati.png";

const data = {
  solo: [
    {
      img: shimla,
      place: "Shimla",
      days: "7 Days - All-Inclusive",
      tag: "Popular",
      link: "/tour-package-data",
    },
    {
      img: udaipur,
      place: "Udaipur",
      days: "5 Days - Adventure",
      tag: "Top Rated",
      link: "/tour-package-data",
    },
    {
      img: jaisalmer,
      place: "Jaisalmer",
      days: "3 Days - Cultural",
      tag: "",
      link: "/tour-package-data",
    },
  ],

  honeymoon: [
    {
      img: manali,
      place: "Manali",
      days: "6 Days - Romantic Escape",
      tag: "Popular",
      link: "/tour-package-data",
    },
    {
      img: goa,
      place: "Goa",
      days: "4 Days - Beach Stay",
      tag: "Top Rated",
      link: "/tour-package-data",
    },
    {
      img: kerala,
      place: "Kerala",
      days: "5 Days - Backwater Cruise",
      tag: "",
      link: "/tour-package-data",
    },
  ],
  family: [
    {
      img: ooty,
      place: "Ooty",
      days: "5 Days - Family Fun",
      tag: "Popular",
      link: "/tour-package-data",
    },
    {
      img: darjeeling,
      place: "Darjeeling",
      days: "4 Days - Nature Tour",
      tag: "",
      link: "/tour-package-data",
    },
    {
      img: jaipur,
      place: "Jaipur",
      days: "3 Days - Heritage Trip",
      tag: "Top Rated",
      link: "/tour-package-data",
    },
  ],

  group: [
    {
      img: rishikesh,
      place: "Rishikesh",
      days: "4 Days - River Rafting",
      tag: "Adventure",
      link: "/tour-package-data",
    },
    {
      img: ladakh,
      place: "Ladakh",
      days: "7 Days - Bike Trip",
      tag: "Popular",
      link: "/tour-package-data",
    },
    {
      img: spiti,
      place: "Spiti Valley",
      days: "6 Days - Road Trip",
      tag: "",
      link: "/tour-package-data",
    },
  ],

  adventure: [
    {
      img: andaman,
      place: "Andaman",
      days: "5 Days - Scuba Diving",
      tag: "Top Rated",
      link: "/tour-package-data",
    },
    {
      img: kasol,
      place: "Kasol",
      days: "4 Days - Trekking",
      tag: "",
      link: "/tour-package-data",
    },
    {
      img: meghalaya,
      place: "Meghalaya",
      days: "6 Days - Cave Exploration",
      tag: "Popular",
      link: "/tour-package-data",
    },
  ],

  spiritual: [
    {
      img: varanasi,
      place: "Varanasi",
      days: "3 Days - Temple Visit",
      tag: "Sacred",
      link: "/tour-package-data",
    },
    {
      img: rameshwaram,
      place: "Rameshwaram",
      days: "4 Days - Pilgrimage",
      tag: "",
      link: "/tour-package-data",
    },
    {
      img: tirupati,
      place: "Tirupati",
      days: "2 Days - Darshan Tour",
      tag: "Popular",
      link: "/tour-package-data",
    },
  ],
};

const HolidaySection = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("solo");

  const tabs = [
    { key: "solo", label: "Solo Travel" },
    { key: "honeymoon", label: "Honeymoon" },
    { key: "family", label: "Family" },
    { key: "group", label: "Group" },
    { key: "adventure", label: "Adventure" },
    { key: "spiritual", label: "Spiritual" },
  ];

  return (
    <div className="holiday-main">
      <h1 className="holiday-title">Explore Holiday by Theme</h1>

      {/* Tabs */}
      <div className="holiday-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`tab-btn ${activeTab === tab.key ? "active" : ""}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Cards */}
      <div className="holiday-grid">
        {data[activeTab].map((item, index) => (
          <div
            className="holiday-card"
            key={index}
            onClick={() =>
              navigate(item.link, {
                state: { title: item.place },
              })
            }
          >
            <div className="image-wrapper">
              {item.tag && <span className="tag">{item.tag}</span>}
              <img src={item.img} alt={item.place} />
            </div>

            <div className="card-content">
              <p className="place">{item.place}</p>
              <h3>{item.days}</h3>
            </div>
          </div>
        ))}
      </div>

      <Link to="/holiday-view-more">
        <button className="view-btnn">View More</button>
      </Link>
    </div>
  );
}
export default HolidaySection